import { DegreeInterface } from '@/common/interface/ty_type';
const DEGREE_MAP: DegreeInterface = {
  low: {
    name: "低",
    index: 0,
    chance: 57,
    count: 5,
    unitNum: 50,
    goodValue: 16,
    normalValue: 8,
    badValue: 4
  },
  middle: {
    name: "中",
    index: 1,
    chance: 41,
    count: 14,
    unitNum: 88,
    goodValue: 10,
    normalValue: 5,
    badValue: 3
  },
  high: {
    name: "高",
    index: 2,
    chance: 30,
    count: 20,
    unitNum: 100,
    goodValue: 8,
    normalValue: 4,
    badValue: 2
  },
  custom: {
    name: "自定义",
    index: 3
  }
}

export {
  DEGREE_MAP
}